import React from 'react';

import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const Spinner = () => (
    <Box display="flex" flexGrow={1} p={2} justifyContent="center">
      <CircularProgress />
    </Box>
);

export default Spinner